<template>
    <div id="app">
<!--       插入header-->
        <router-view></router-view>

<!--插入footer-->
    </div>
</template>

<script>


    export default {
        name: 'App',

        methods: {
            scrollToTop() {
                let currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                if (currentScroll > 0) {
                    window.requestAnimationFrame(this.scrollToTop);
                    window.scrollTo(0, currentScroll - (currentScroll / 5));
                }
            }
        }
    }

</script>


<style>
body {
  width: 100%;
  font-family: Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue